
import Vue from 'vue';
import { components } from '../page-items';
import carrayGroup from '../page-groups/CArrayGroup.vue';

export default Vue.extend({
  components: {
    ...components, carrayGroup
  },
  props: {
    group: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} },
    errorResponse: { type: Object, default: () => {} },
    groupDisabled: { type: Boolean, default: false }
  }
});
